<template>
  <div class="box">
    <table class="table is-fullwidth" v-show="!loading && docs.length > 0">
      <thead>
        <tr>
          <th>Request Date</th>
          <th>Employee ID</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Email</th>
          <th>From</th>
          <th>To</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="leave in docs" :key="leave._id">
          <td>{{ leave.createdAt | date }} <p>{{ leave.createdAt | time }}</p></td>
          <td>{{ leave.employeeId }}</td>
          <td>{{ leave.name }}</td>
          <td>{{ leave.mobile }}</td>
          <td>{{ leave.email }}</td>
          <td>{{ leave.startDate | date }}</td>
          <td>{{ leave.endDate | date }}</td>
          <td class="actions">
            <router-link :to="`/request/leave/view/${leave._id}`"
              >View</router-link
            >
            <router-link :to="`/request/leave/edit/${leave._id}`"
              >Edit</router-link
            >
            <router-link
              :to="`/request/leave/delete/${leave._id}`"
              class="has-text-danger"
              >Delete</router-link
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div class="has-text-centered">
      <button class="button is-loading is-large" v-show="loading"></button>
      <p class="has-text-grey" v-show="!loading && docs.length === 0">
        No records matching these criteria
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["leave/docs"];
    },
    loading() {
      let component = this;
      return component.$store.getters["leave/loading"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("leave/index");
  }
};
</script>
<style lang="scss" scoped>
.actions {
  a {
    padding-right: 16px;
  }
}
button.is-loading {
  border: none;
}
</style>
